var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 512"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "url(#icon_svg__a)",
    rx: 128
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M150 135.1c0-7.98 3.2-15.64 8.87-21.28a30.4 30.4 0 0 1 21.42-8.82H331.7c8.04 0 15.74 3.17 21.42 8.82A30 30 0 0 1 362 135.1v15.05c0 21.69-9.22 44.9-21.2 64.96a215 215 0 0 1-31.3 40.39 215 215 0 0 1 31.27 40.4c12 20.04 21.23 43.28 21.23 64.95v15.05c0 7.98-3.2 15.64-8.87 21.28a30.4 30.4 0 0 1-21.42 8.82H180.3a30.4 30.4 0 0 1-21.42-8.82A30 30 0 0 1 150 375.9v-15.05c0-21.69 9.22-44.9 21.2-64.96a215 215 0 0 1 31.3-40.39 216 216 0 0 1-31.27-40.4c-12-20.04-21.23-43.28-21.23-64.95z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__a",
    x1: 61,
    x2: 469,
    y1: 36,
    y2: 491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fa7c40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec364f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_svg__b",
    width: 230.8,
    height: 319.8,
    x: 142.6,
    y: 99.6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })))));
};
export default SvgIcon;